export default {
    init: {},
    selectedBook: null,
    bookCreatedNow: false

}